import React, { useState } from "react";
import { Modal, Button, FormGroup, FormControl } from "react-bootstrap";
import TagUpdateBlock from "../components/TagUpdateBlock";
import { DEFAULT_SELECT_VALUE } from "../constants";

const TagsListUpdateModal = (
    {
        editableTag,
        tagsList,
        show,
        onSave,
        onUpdate,
        onClose,
        onAddToList,
    }
) => {
    const [isAddTagMode, setAddTagMode] = useState(false);
    const [selectedTag, setSelectedTag] = useState(null);

    const handleCloseModal = () => {
        setAddTagMode(false);
        onClose();
    }

    const handleAddTagToList = (tag) => {
        setAddTagMode(false);
        onAddToList(tag);
    };

    const handleSaveTag = () => {
        if (!selectedTag || selectedTag === DEFAULT_SELECT_VALUE) {
            return;
        }

        const tag = tagsList.find(({titleRu, titleEn}) => titleRu === selectedTag || titleEn === selectedTag)
        onSave(tag);
        setSelectedTag(null);
    };

    return (
        <Modal show={show} onHide={handleCloseModal}>
            <Modal.Header>
                <Modal.Title>{editableTag ? 'Редактировать' : 'Теги'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!editableTag && (
                    <FormGroup>
                        <FormControl
                            defaultValue={selectedTag || DEFAULT_SELECT_VALUE}
                            componentClass="select"
                            name="tagsList"
                            onChange={(e) => setSelectedTag(e.target.value)}
                        >
                            <option value="">{DEFAULT_SELECT_VALUE}</option>
                            {tagsList?.map((tag) => (
                                <option
                                    key={tag.id}
                                    value={tag.titleRu}
                                >
                                    {tag.titleRu ?? tag.titleEn}
                                </option>
                            ))}
                        </FormControl>
                    </FormGroup>
                )}
                {isAddTagMode || editableTag
                    ? <TagUpdateBlock
                        editableTag={editableTag}
                        onSave={handleAddTagToList}
                        onUpdate={onUpdate}
                        onClose={handleCloseModal}
                    />
                    : <Button onClick={() => setAddTagMode(true)}>
                        Добавить новый
                    </Button>
                }
            </Modal.Body>
            {!editableTag && (
                <Modal.Footer>
                    <Button onClick={handleSaveTag}>Сохранить</Button>
                    <Button onClick={handleCloseModal}>Закрыть</Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default TagsListUpdateModal;
